import {configureStore} from '@reduxjs/toolkit';
import pageReducer from './features/pages/pageSlice';
import answersReducer from './features/answers/answerSlice';
import resultSlice from './features/results/resultSlice';
import rankingSlice from './features/rankingSlice';

export const store = configureStore({
  reducer: {
    page: pageReducer,
    answers: answersReducer,
    result: resultSlice,
    rankings: rankingSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
